<template>
  <div class="notification">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="messageCon">
      <div class="messageTabBox">
        <div class="proCon">
          <div class="tabTitle clearfix">
            <div class="input-group pull-right">
              <input type="text" class="form-control" placeholder="请输入关键词" ref="keyword" @keyup.enter="searchNotification()">
              <span class="input-group-btn">
                <button tabindex="0" class="btn" type="submit" aria-label="Search" @click="searchNotification()">
                  <img class="search-icon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" width="20px" alt="Search">
                </button>
              </span>
            </div><!-- /input-group -->
          </div>
          <div class="tabCon">
            <!-- <v-notificationTable :messageData='messageData' navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-notificationTable> -->
            <div class="tableCom">
              <div class="tableTitle">
                <span class="col-lg-7 col-md-5 col-xs-8 col-sm-8">标题</span>
                <span class="col-lg-4 col-md-3 hidden-xs hidden-sm">
                  <a class="timeSort">时间<span class="sortIcon"></span></a>
                </span>
                <span class="col-lg-1 col-md-1 hidden-xs hidden-sm">操作</span>
              </div>
              <div class="tableCon">
                <p class="tableTr clearfix" v-for="(item,index) in messageData" :key="index" @click.stop ="mobileClick(item)">
                  <span @click.stop ="mobileClick(item)" class="col-lg-7 col-md-5 col-xs-8 col-sm-8">
                    <i class="alreadyRead" v-if="item.viewNumber>0"></i>
                    <i class="unread" v-if="item.viewNumber==0"></i>{{item.noticeTitle}}
                  </span>
                  <!--<i class="alreadyRead"></i> 已读 unread未读 -->
                  <span class="col-lg-4 col-md-3 hidden-xs hidden-sm">{{item.createTime|time}}</span>
                  <span class="col-lg-1 col-md-1 hidden-xs hidden-sm" @click.stop="viewNotice(item)"><a>查看</a></span>
                </p>
              </div>
            </div>
            <div class="clearfix hidden-xs hidden-sm">
              <v-pagination :total='messageTotal' :display='10' :current-page='currentPage' @pagechange="pagechange"></v-pagination>
            </div>

          </div>
        </div>
      </div>
      <div class="btnCon">
      <el-button v-show="!lineShow" type="button" class="btn btn-default btn-lg hidden-md hidden-lg" @click="morePagechange()">MORE</el-button>
      <p class="lineCon" v-show="lineShow">
        <span class="line"></span>
        <el-button type="text" class="hidden-sm hidden-md hidden-lg" disabled>我也是有底线的</el-button>
        <span class="line"></span>
      </p>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import notificationTable from '@/components/notificationTable'
  import pagination from '@/components/pagination'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        footerColumnInfos:[],
        bannerInfo: {title: '公告通知',content: "notification"},
        webConfigInfo: {},
        messageData: [],
        messageExtData: [],
        messageTotal:0,
        currentPage:1,
        currentPageMore:2,
        noticeQuery:{},
        noticeResponseDto:{},
        lineShow:false

      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-notificationTable': notificationTable,
      'v-pagination': pagination,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainNoticeInfo', {
        pageNo : this.currentPage,
        pageSize : 10
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.noticeResponseDto = this.data.noticeResponseDto;
        this.messageData = this.noticeResponseDto.noticeDtos;
        this.messageTotal = Number(this.noticeResponseDto.pageInfo.totalRecords);
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      morePagechange(){
        this.currentPageMore = this.currentPageMore + 1;
        // ajax请求, 向后台发送 currentPage, 来获取对应的数据
        this.$axios.post('/onelink.mdata.main.api/notice/findPublicNotice', {
          noticeTitle:this.$refs.keyword.value,
          pageSize:5,
          pageNo:this.currentPageMore
        }).then((res) => {
          if(res.data.noticeDtos.length <= 0){
            this.lineShow=true;
        }
          this.data = res.data;
          this.messageExtData = this.data.noticeDtos;
          this.messageExtData.forEach(element =>{
            this.messageData.push(element);
          });
          this.messageTotal = Number(this.data.pageInfo.totalRecords);
        }).catch((err) => {
          
        })
      },
      //分页查询公告信息
      pagechange(currentPage){
          this.currentPage = currentPage;
          // ajax请求, 向后台发送 currentPage, 来获取对应的数据
          this.$axios.post('/onelink.mdata.main.api/notice/findPublicNotice', {
            noticeTitle:this.$refs.keyword.value,
            pageSize:10,
            pageNo:currentPage
          }).then((res) => {
            this.data = res.data;
            this.messageData = this.data.noticeDtos;
            this.messageTotal = Number(this.data.pageInfo.totalRecords);
          }).catch((err) => {
            
          })
      },
      viewNotice(item){
        this.$router.push({ path: '/notificationDetails', query: { noticeId:item.noticeInfoId} })
      },
      searchNotification(){
        this.lineShow=false;
        // ajax请求, 向后台发送 currentPage, 来获取对应的数据
        this.currentPage = 1;
        this.$axios.post('/onelink.mdata.main.api/notice/findPublicNotice', {
          noticeTitle:this.$refs.keyword.value,
          pageSize:10,
          pageNo:this.currentPage
        }).then((res) => {
          this.data = res.data;
          this.messageData = this.data.noticeDtos;
          this.messageTotal = Number(this.data.pageInfo.totalRecords);
        }).catch((err) => {
          
        })
      },
//      点击整行事件
      mobileClick(val){
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.viewNotice(val);
        } else {
          return;
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/notification/index.vue